module.exports = __webpack_public_path__ + "img/condo.00c5b7d.png";